module.exports = __webpack_public_path__ + "Roboto-RegularItalic.f3660f493ea5e5206484.eot";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-RegularItalic.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-RegularItalic.eot
// module chunks = 34